import React from 'react';
import PropTypes from 'prop-types';
import resizeListener from '../../../components/resizeListenerComponent';
import BarChart from './BarChart';

class FollowersByDateStatistics extends React.Component {
    render() {
        const followers = this.props.lastNFollowers.slice(0).reverse();
        return (
            <div className="panel">
                <h3>Nye følgere</h3>
                <BarChart
                    data={followers}
                    width={this.props.width}
                    x="date"
                    y="count"
                />
            </div>
        );
    }
}

FollowersByDateStatistics.propTypes = {
    followers: PropTypes.object,
    width: PropTypes.number,
    lastNFollowers: PropTypes.arrayOf(
        PropTypes.shape({
            date: PropTypes.string.isRequired,
            count: PropTypes.number.isRequired,
        })
    ),
};

export default resizeListener(FollowersByDateStatistics);
